<script setup lang="ts">
import { useI18n } from '@/composition/i18n'

const { t } = useI18n()
</script>

<template>
  <div class="error-wall load-error">
    <div class="error-container">
      <h1>{{ t('notFound.ohNo') }}</h1>
      <h3>{{ t('notFound.weHaveHadAnError') }}</h3>
      <h4>{{ t('notFound.error404') }}</h4>
      <p>{{ t('notFound.sorryPleaseCheckBack') }}</p>
    </div>
  </div>
</template>
